import { QR_LABEL_SIZE_MM, canonicalTankQrPayload } from "./qrPayload";

export interface TankQrLabelSpec {
  widthMm: number;
  heightMm: number;
  encodedPayload: string;
  humanReadableCode: string;
}

export function buildTankQrLabelSpec(tankCode: string): TankQrLabelSpec {
  const canonical = canonicalTankQrPayload(tankCode);

  return {
    widthMm: QR_LABEL_SIZE_MM,
    heightMm: QR_LABEL_SIZE_MM,
    encodedPayload: canonical,
    humanReadableCode: canonical,
  };
}
